import React from "react";
import logoImage from "./logo.png";

function Logo(props) {
  return <img src={logoImage} alt="Rivile-mscan" {...props} />;
}

export default Logo;
